import { jsx as _jsx } from "react/jsx-runtime";
function SvgArrowDUpIcon(props) {
    return (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M11.2537 6.36633C11.6518 5.87783 12.3514 5.8779 12.7494 6.36648L20.7455 16.1836C21.3188 16.8875 20.8607 18 19.9976 18H4.00243C3.13917 18 2.68115 16.8873 3.25467 16.1834L11.2537 6.36633Z", fill: "currentColor" }, void 0) }), void 0));
}
export default SvgArrowDUpIcon;
